var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import DefaultProviders from "../ui/DefaultProviders";
import ErrorBoundary from "../ui/templates/ErrorBoundary";
import PdfPage from "../ui/molecules/PdfPage";
var PdfStatement = function (_a) {
    var config = _a.config, selectedAccountId = _a.selectedAccountId, onReturnToStatementListClick = _a.onReturnToStatementListClick;
    return (_jsx(DefaultProviders, __assign({ config: __assign(__assign({}, config), { apiErrorCallback: function () { } }) }, { children: _jsx(ErrorBoundary, { children: _jsx(PdfPage, { selectedAccountId: selectedAccountId, onReturnToStatementListClick: onReturnToStatementListClick }) }) })));
};
export default PdfStatement;
